import { setGA4Event } from "@bevco/Store/Handlers/Utilities/CustomTracking";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { request } from "@insite/client-framework/Services/ApiService";

const emailsUrl = "/api/v1/contactusform/createAccount";

type SubmitCreateAccountFormParameter = {
    emailRecipients: string;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<SubmitCreateAccountFormParameter, FormData>;

export const PopulateApiParameter: HandlerType = async (props: any) => {
    const state = (props.getState() as any).customCreateAccountForm.fieldValues;

    const payload = {
        LoginEmail: state.userEmail,
        FirstName: state.userFirstName,
        LastName: state.userLastName,
        Company: state.company,
        JobTitle: state.jobTitle,
        Website: state.websiteUrl,
        Industry: state.industry,
        BusinessType: state.businessType,
        PreviousPurchaseWithBEVCO: `${state.previouslyPurchased === "true"}`,

        CompanyNameShipping: state.shippingCompany,
        AddressLine1Shipping: state.shippingAddressLineOne,
        AddressLine2Shipping: state.shippingAddressLineTwo,
        PhoneShipping: state.shippingPhone,
        CityShipping: state.shippingCity,
        ZipPostalCodeShipping: state.shippingZipCode,
        CountryShipping: state.shippingCountry ?? "",
        StateProvinceShipping: state.shippingState,

        TaxCheckboxChecked: state.taxExempt === "true" ? "Yes" : "No",
        UseShippingAddress: state.useShippingAddress === "true" ? "true" : "false",
    } as any;

    if (state.useShippingAddress === "true") {
        payload.CompanyNameBilling = state.shippingCompany;
        payload.AddressLine1Billing = state.shippingAddressLineOne;
        payload.AddressLine2Billing = state.shippingAddressLineTwo;
        payload.PhoneBilling = state.shippingPhone;
        payload.CityBilling = state.shippingCity;
        payload.ZipPostalCodeBilling = state.shippingZipCode;
        payload.CountryBilling = state.shippingCountry ?? "";
        payload.StateProvinceBilling = state.shippingState;
    } else {
        payload.CompanyNameBilling = state.billingCompany;
        payload.AddressLine1Billing = state.billingAddressLineOne;
        payload.AddressLine2Billing = state.billingAddressLineTwo;
        payload.PhoneBilling = state.billingPhone;
        payload.CityBilling = state.billingCity;
        payload.ZipPostalCodeBilling = state.billingZipCode;
        payload.CountryBilling = state.billingCountry ?? "";
        payload.StateProvinceBilling = state.billingState;
    }

    if (state.taxExempt === "true") {
        const file = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(state.file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
        payload.FileUpload1 = file;
        payload.FileUploadName1 = state.file.name;
    }

    props.apiParameter = {} as any;
    Object.keys(payload).forEach(key => {
        props.apiParameter[key] = payload[key];
    });
};

export function multipart<Parameter, Result = Parameter>(endpoint: string, formData: any) {
    const customertype = "new";
    const formType = "Create an Account";
    const formID = "createAccountForm";
    const accountNumber = "";
    const industrySelection = formData.Industry;
    const businessType = formData.BusinessType;
    setGA4Event([], "createAccountSubmission", { customertype,formType,formID, accountNumber,industrySelection,businessType});
    
    return request<Result>(
        endpoint,
        "POST",
        { Accept: "application/json", "Content-Type": "application/json" },
        JSON.stringify(formData),
    );
}

export function submitCreateAccountFormApi(parameter: any) {
    return multipart<any, void>(`${emailsUrl}`, parameter);
}

export const SendDataToApi: HandlerType = async props => {
    await submitCreateAccountFormApi(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitCreateAccountForm = createHandlerChainRunner(chain, "SubmitContactForm");
export default submitCreateAccountForm;
